import React, { useMemo, useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { BiSearch } from 'react-icons/bi'
import { IoIosArrowBack } from 'react-icons/io'
import WatchBody from '../comps/watchBody'
import StoriesRail from '../comps/storiesRail'
import * as actions from '../data/posts_data'
import * as authAction from '../store/authAction'
import * as likeActions from '../data/like_data'
import * as followActions from '../data/follow_data'
import { isShortPost, leavePath } from '../utils/mediaRoute'
import { bindStoryChrome } from '../utils/storyChrome'
import PostModel from '../model/posts'

const rowToPost = (row) => {
  if (!row) return null
  const post = new PostModel(
    row.id || row.postid,
    row.image || row.content,
    row.title,
    row.type,
    row.userid,
    row.tages,
    row.disc || row.discrption || row.description,
    row.time,
    row.thumbnail,
    row.vCount || row.views,
    row.comm,
    row.pCount,
    row.dCount,
    row.userImg,
    row.email,
    row.userLink,
    row.vleading
  )
  return post.id ? post : null
}

const Watch = () => {
  const { category } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const startId = searchParams.get('v')
  const startComment = searchParams.get('c')
  const soundParam = searchParams.get('sound')
  const startItem = location.state && location.state.item
  const [clipPost, setClipPost] = useState(() => (
    startItem && startId && String(startItem.id) === String(startId) ? startItem : null
  ))
  const soundFeed = location.state && location.state.soundFeed
  const fromSound = soundParam || (location.state && location.state.fromSound)
  const fromPath = location.state && location.state.from
  const showBack = Boolean(fromSound || startId || fromPath)

  const goBack = () => {
    const target = leavePath(location)
    const here = `${location.pathname}${location.search || ''}`
    const next = target && target !== here ? target : '/'
    if (next === '/watch' || next.startsWith('/watch')) {
      navigate('/watch', { replace: true, state: { resumeId: startId } })
      return
    }
    navigate(next, { replace: true, state: startId ? { resumeId: startId } : undefined })
  }
  const dispatch = useDispatch()
  const [isload, SetLoad] = useState(true)
  const [error, setError] = useState('')
  const [page, setPage] = useState(5)
  const [chromeVisible, setChromeVisible] = useState(true)
  const [immersive, setImmersive] = useState(false)
  const storyChrome = useRef(null)

  useEffect(() => {
    storyChrome.current = bindStoryChrome(setChromeVisible)
    return () => storyChrome.current?.destroy()
  }, [])

  useEffect(() => {
    document.body.classList.toggle('watch-immersive', immersive)
    return () => document.body.classList.remove('watch-immersive')
  }, [immersive])

  useEffect(() => {
    const loadPageData = async () => {
      const userData = localStorage.getItem('userdata')
      if (userData) {
        try {
          const { id, pid } = JSON.parse(userData)
          await dispatch(authAction.auth(id, pid))
          await dispatch(likeActions.get_my_likes())
          await dispatch(followActions.get_follow())
        } catch (err) {}
      }

      SetLoad(true)
      try {
        await dispatch(actions.get_posts(0, 5))
      } catch (err) {
        setError(err.message)
      } finally {
        SetLoad(false)
      }
    }

    loadPageData()
  }, [dispatch])

  useEffect(() => {
    if (!startId) return undefined
    if (clipPost && String(clipPost.id) === String(startId)) return undefined
    if (startItem && String(startItem.id) === String(startId)) {
      setClipPost(startItem)
      return undefined
    }
    let cancelled = false
    fetch(`/api/postAi/postDeatils/${encodeURIComponent(startId)}`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return
        const rows = data && data.msg
        const row = Array.isArray(rows)
          ? rows[0]
          : rows && (rows.id || rows.postid)
            ? rows
            : rows && typeof rows === 'object'
              ? Object.values(rows)[0]
              : null
        const post = rowToPost(row)
        if (post) setClipPost(post)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [startId, startItem, clipPost])

  const getData2 = async () => {
    try {
      await dispatch(actions.get_postss(page, 3))
      setPage(page + 3)
    } catch (err) {
      setError(err.message)
    }
  }

  const shorts = useSelector(state => state.PostReducer.followShort)
  const longs = useSelector(state => state.PostReducer.followLong)
  const list2 = useMemo(() => {
    const shortsList = Array.isArray(shorts) ? shorts : []
    const longsList = Array.isArray(longs) ? longs : []
    const pinned = (clipPost && String(clipPost.id) === String(startId))
      ? clipPost
      : (startItem && startId && String(startItem.id) === String(startId) ? startItem : null)
    const source = Array.isArray(soundFeed) && soundFeed.length
      ? [...soundFeed]
      : (pinned && isShortPost(pinned)) || shortsList.length ? [...shortsList] : [...longsList]
    if (startId && pinned && !source.some(post => String(post.id) === String(startId))) {
      return [pinned, ...source]
    }
    return source
  }, [shorts, longs, startId, startItem, soundFeed, clipPost])

  const resumeId = startId || (location.state && location.state.resumeId)

  return (
    <section className={`WatchPage${immersive ? ' isImmersive' : ''}`}>
      <Helmet>
        <title>Watch new things, videos and people</title>
        <meta name="description" content="Here you can watch best short and long videos." />
        <meta name="keywords" content="watch,pinweelo website,watch page" />
        <link rel="canonical" href={`https://pinweelo.com/watch${startId ? `?v=${encodeURIComponent(startId)}` : ''}`} />
        <meta name="theme-color" content="#000000" />
        <meta name="apple-mobile-web-app-status-bar-style" content="#000000" />
      </Helmet>

      <div
        className="watchPageShell"
        onWheel={event => storyChrome.current?.onWheel(event)}
        onTouchStart={event => storyChrome.current?.onTouchStart(event)}
        onTouchMove={event => storyChrome.current?.onTouchMove(event)}
      >
        {showBack ? (
          <button
            type="button"
            className="watchBackButton"
            onClick={goBack}
            aria-label="Go back"
          >
            <IoIosArrowBack />
          </button>
        ) : (
          <StoriesRail variant="watch" hidden={!chromeVisible} />
        )}
        <div className="watchFeed">
          <button
            type="button"
            className="watchSearchButton"
            onClick={() => navigate('/search')}
            aria-label="Search"
          >
            <BiSearch />
          </button>
          <WatchBody
            key={soundFeed && soundFeed.length ? `sound-${soundParam || 'feed'}` : 'watch-feed'}
            page={page}
            fetchData={getData2}
            isload={isload}
            list={list2 || []}
            error={error}
            startId={resumeId}
            startComment={startComment}
            storyChrome={storyChrome}
            onImmersive={setImmersive}
            rememberLine={!soundFeed}
          />
        </div>
        {immersive ? (
          <button
            type="button"
            className="watchShowUi"
            onClick={() => setImmersive(false)}
          >
            Show buttons
          </button>
        ) : null}
      </div>
    </section>
  )
}

export default Watch;
